/**
 * All CEX IDs supported by Cede SDK (mapped to CCXT exchange IDs).
 * Used for SDK features: authentication, trading, portfolio.
 *
 * @note Does NOT include Hyperliquid (which is in @cede/utils version) or onchain DEX.
 * @see SUPPORTED_EXCHANGES in supported-cex.ts for Hub platform exchanges (includes Hyperliquid + Aerodrome)
 */
export const CEDE_CEXS = {
  BINANCE: "binance",
  COINBASE: "coinbase",
  KRAKEN: "kraken",
  GATEIO: "gateio",
  OKX: "okx",
  BITFINEX: "bitfinex",
  HTX: "huobi",
  KUCOIN: "kucoin",
  BYBIT: "bybit",
  BITGET: "bitget",
  BITSTAMP: "bitstamp",
  BITMART: "bitmart",
  MEXC: "mexc",
  COINBASE_EXCHANGE: "coinbaseexchange",
  CRYPTOCOM: "cryptocom",
  BITHUMB: "bithumb",
  KRAKEN_FUTURES: "krakenfutures",
  LBANK: "lbank",
};

export type CEDE_CEXS = (typeof CEDE_CEXS)[keyof typeof CEDE_CEXS];

/** CEX that will be supported soon (promoted on landing pages) */
export const CEDE_CEXS_SOON_SUPPORTED = {
  GEMINI: "gemini",
  BINANCE_US: "binanceus",
};
